// Some image is still loading
let loading = false;
const queue = [];

function loadNext() {
  if (queue.length === 0) return;
  const { img, src } = queue.shift();
  loading = true;
  img.src = src;
}

export function put(src, onload) {
  const img = new Image();
  img.onload = () => {
    loading = false;
    loadNext();
    onload();
  };
  queue.push({ img, src });
  if (queue.length === 1 && !loading) {
    loadNext();
  }
}
